import {
  mdiPoll,
  mdiHistory,
  mdiCalendar,
  mdiNewspaperVariant,
  mdiFileOutline,
  mdiFile,
  mdiFrequentlyAskedQuestions,
  mdiDomain,
  mdiHandshake,
  mdiChat,
  mdiCommentQuestionOutline,
  mdiAccount,
  mdiCog,
  mdiCommentQuoteOutline,
  mdiInformationOutline,
  mdiFormatQuoteClose,
  mdiCalendarToday,
  mdiAttachment,
  mdiChatOutline,
  mdiSendOutline,
  mdiCurrencyEur,
  mdiChatQuestionOutline
} from '@mdi/js'

export default [
  {
    title: 'Uutiset',
    icon: mdiFormatQuoteClose,
    to: 'admin-news-list',
    dynamicTitle: true,
    dynamicTitleKey: 'news'
  },
  {
    title: 'Tapahtumat',
    icon: mdiCalendarToday,
    to: 'admin-event-list',
  },
  {
    title: 'Kyselyt',
    icon: mdiPoll,
    to: 'admin-poll-list',
  },
  {
    title: 'Tiedostot',
    icon: mdiAttachment,
    to: 'admin-resource-list',
  },
  {
    title: 'Kysymykset & vastaukset',
    icon: mdiChatQuestionOutline,
    to: 'admin-faq-list',
    tenantAdmin: true
  },
  {
    title: 'Palautekanava',
    icon: mdiSendOutline,
    to: 'admin-feedback-list',
    feedbackManager: true,
    adminNotificationKey: 'newFeedbackCount'
  },
  {
    title: 'Meidän yritys',
    icon: mdiInformationOutline,
    to: 'admin-page-list',
    dynamicTitle: true,
    dynamicTitleKey: 'our_company',
    tenantAdmin: true
  },
  {
    title: 'Henkilöstöedut',
    icon: mdiCurrencyEur,
    to: 'admin-benefit-list',
    optional: true,
    optional_key: 'benefits_enabled',
    tenantAdmin: true
  },
  {
    title: 'Keskustelukanavat',
    icon: mdiChatOutline,
    to: 'admin-chat-channel-list',
    optional: true,
    optional_key: 'chat_enabled',
    tenantAdmin: true
  },
  {
    subheader: 'Ylläpito',
    tenantAdmin: true
  },
  {
    title: 'Käyttäjät',
    icon: mdiAccount,
    to: 'admin-user-list',
    tenantAdmin: true
  },
  {
    title: 'Palauteasetukset',
    icon: mdiCog,
    to: 'admin-settings',
    tenantAdmin: true
  },
  {
    subheader: 'Tietoja',
    tenantAdmin: true
  },
  {
    title: 'Päivitykset',
    icon: mdiHistory,
    to: 'admin-changelog',
    tenantAdmin: true
  },
]
